import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { api } from "./api";
import { baseApi } from "./baseApi";
import auth from "./slices/authSlice";

const appReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
  auth,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'auth/logout') {
    // Clear entire Redux store including RTK Query cache to prevent data leaking across users
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (gDM) => gDM().concat(api.middleware, baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
